import { ReactNode } from "react";
import { styled } from "styled-components";

interface Props {
  bgColor: string;
  textComponent: ReactNode;
  height?: number;
  onClick?: () => void;
}

const Badge = ({ bgColor, textComponent, height = 24, onClick }: Props) => {
  return (
    <StyledContainer
      $bgColor={bgColor}
      $heightValue={height}
      onClick={() => onClick && onClick()}
    >
      {textComponent}
    </StyledContainer>
  );
};

export default Badge;

const StyledContainer = styled.div<{ $bgColor: string; $heightValue: number }>`
  border-radius: 4px;
  padding: 0px 8px;
  align-items: center;
  background-color: ${({ $bgColor }) => $bgColor as string};
  height: ${({ $heightValue }) => $heightValue}px;
`;
